import { useState, useCallback } from 'react';

export const useToggle = initialState => {
  const [state, setState] = useState(initialState);

  const toggle = useCallback(() => setState(aState => !aState), []);

  return { state, toggle, setState };
};
